<template>
    <div class="page--produtos-participantes d-flex align-items-end justify-content-center flex-column">
        <b-container>
            <h1>Produtos Participantes</h1>

            <b-row class="d-flex justify-content-center align-items-center mt-3">
                <b-col cols="12" md="6">
                    <p class="p--produtos-lista-modal text-center">
                        <a href="absoluto/assets/pdf/produtos_participantes.pdf?t=1" target="_blank"> Clique aqui</a> para ver a lista completa
                    </p>
                </b-col>
            </b-row>

            <!-- ### CARROSSEL ### -->
            <div class="mt-5" v-if="isCarrossel">
                <SlickCarrossel :settings="settingsCarousel">
                    <div><img src="absoluto/assets/images/produtos/produtos.png?t=4" alt=""></div>
                    <div><img src="absoluto/assets/images/produtos/produtos.png?t=4" alt=""></div>
                    <div><img src="absoluto/assets/images/produtos/produtos.png?t=4" alt=""></div>
                    <div><img src="absoluto/assets/images/produtos/produtos.png?t=4" alt=""></div>
                    <div><img src="absoluto/assets/images/produtos/produtos.png?t=4" alt=""></div>
                </SlickCarrossel>
            </div>
            <!-- ### FIM - CARROSSEL  ### -->

            <!-- ### IMG ESTÁTICA ### -->
            <b-row class="d-flex justify-content-center align-items-center" v-else>
                <b-col cols="12" class="d-flex justify-content-center align-items-center">
                    <div >
                        <picture>
                            <source media="(min-width:320px)" srcset="absoluto/assets/images/produtos/produtos.webp">
                            <img src="absoluto/assets/images/produtos/produtos.webp"
                            :alt='Produtos'
                            :title='Produtos'
                            />
                        </picture>
                    </div>
                </b-col>
            </b-row>
            <!-- ### FIM - IMG ESTÁTICA ### -->
        </b-container>

        <!-- ### MODAL ### -->
        <Modal
            v-if="openModalProdutos"
            :name="'Modal Produtos'"
            :openModal="openModalProdutos"
            :size="'lg'"
            :classCustom="'modal-produtos'"
        >
            <b-row>
                <b-col class="d-flex align-items-center justify-content-end">
                    <div
                        class="wrapper-icon-modal d-flex align-items-center justify-content-center"
                    >
                        <b-icon
                            @click="openModalProdutos = false"
                            icon="x"
                        ></b-icon>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="d-flex justify-content-center align-items-center">
                    <h3>CONFIRA OS PRODUTOS PARTICIPANTES</h3>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="d-flex justify-content-center align-items-center mt-3">
                    <div class="wrapper-table">
                        <table class="table table--blank">
                            <tbody>
                                <tr :item="item" v-for="(item, key) in produtosParticipantes" :key="key">
                                    <td>
                                        {{ item.produto }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-col>
            </b-row>
        </Modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import checkView from 'vue-check-view'
    Vue.use(checkView)
    export default {
        name        : "Produtos",
        sliding     : null,
        components  : {
            Modal: () => import('../components/Modal'),
            SlickCarrossel: () => import('../components/Carrossel.vue'),
        },
        data() {
            return {
                Produtos : "Produtos Yoki: Caseiríssima, Batata palha tradicional, Cheddar fenomenal, Amendoim japonês, Yokitos",
                openModalProdutos   : false,
                isCarrossel         : false, //TRUE para ativar Carrossel -- FALSE para imagem estática
                HeaderTable: [
                    {label: 'TITLE 1'},
                    {label: 'TITLE 2'},
                ],
                produtosParticipantes: [
                    { produto: 'Nonoon nno' },
                    { produto: 'Nonoon n nononon non nononnon ono' },
                    { produto: 'Nonoon n nononnon ono' },
                    { produto: 'Nonoon n nononon non nononnon ono' },
                    { produto: 'Nonoon nononnon ono' },
                    { produto: 'Nonoon n nononnon ono' },
                    { produto: 'Nonoon n nononnon ono' },
                    { produto: 'Nonoon n nononon non nononnon ono' },
                    { produto: 'Nonoon n nononon non nononnon ono' },
                    { produto: 'Nonoon n nononon non nononnon ono' },
                ],
                settingsCarousel: {
                    "centerMode": true,
                    "dots": true,
                    "centerPadding": "20px",
                    "focusOnSelect": true,
                    "infinite": true,
                    "slidesToShow": 1,
                    "speed": 500,
                    "responsive": [
                        {
                        "breakpoint": 768,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1
                        }
                        },
                        {
                        "breakpoint": 500,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1
                        }
                        }
                    ]
                }
            };
        },
        created() {
            document.addEventListener('keyup', this.onEsc)
        },
        beforeDestroy() {
            document.removeEventListener('keyup', this.onEsc)
        },
        methods: {
            onEsc(e) {
                if (!e) e = window.event
                let keyCode = e.keyCode || e.which
                if (keyCode == '27') {
                    this.openModalProdutos = false
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/global";
    @import "../assets/scss/onepage";
    .page--produtos-participantes {
        height: inherit;
        a,p.p--produtos-lista-modal{
            color: $black;
            font-size: 1.3rem;//24
            line-height: 1.7rem;//24
            text-transform: uppercase !important;
        }
    }
    .modal-produtos {
        .wrapper-table {
            overflow-x: auto;
        }
    }

    .container {
        height: inherit;
    }

    @media (max-width: $mobile) , (orientation:portrait) {
        .page--produtos-participantes {
        }
    }

    // @media (max-height: 740px) and (orientation:landscape) {
    // }
</style>
